module.exports = __webpack_public_path__ + "img/brightpoint_2.4e5bf5b8.png";